import React from 'react';
import { FileText } from 'lucide-react';
import { TabVat } from './Reports';

// Standalone page for the VAT201 report (surfaced in the sidebar under Reports).
export default function VatReport() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <FileText size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">VAT (VAT201)</h1>
          <p className="text-xs text-gray-400">Output VAT for a period, ready for your VAT201 return</p>
        </div>
      </div>
      <TabVat />
    </div>
  );
}
